import { createContext, useCallback, useContext, useState } from "react";

export const GOOD = "good";
export const WORKING = "working";
export const FAIL = "fail";

const StatusContext = createContext();

export const StatusProvider = ({ children }) => {
  const [status, setStatus] = useState({
    appStatus: GOOD,
    services: [],
    toggled: false,
  });

  const addService = useCallback(
    (service) => {
      const index = status.services.findIndex((s) => s.name === service.name);
      // Add to service list if it doesn't exist, otherwise update it
      if (index === -1) {
        return [...status.services, service];
      } else {
        return status.services.map((s) => {
          if (s.name === service.name) {
            return service;
          } else {
            return s;
          }
        });
      }
    },
    [status.services]
  );

  const updateStatus = useCallback(
    ({ appStatus = GOOD, service }) => {
      setStatus((prevStatus) => ({
        ...prevStatus,
        appStatus: appStatus,
        services: service ? addService(service) : prevStatus.services,
      }));
    },
    [addService]
  );

  const toggleStatus = useCallback((toggle) => {
    setStatus((prevStatus) => ({ ...prevStatus, toggled: toggle }));
  }, []);

  return (
    <StatusContext.Provider value={{ status, updateStatus, toggleStatus }}>
      {children}
    </StatusContext.Provider>
  );
};

export const useStatus = () => {
  return useContext(StatusContext);
};
